import debounce from 'lodash.debounce';
$ = jQuery;

class EventsList {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.list = this.root.querySelector('[data-events-list]');
        this.calendar = this.root.querySelector('[data-calendar]');
        this.more = this.root.querySelector('[data-events-more]');
        this.resetButton = this.root.querySelector('[data-events-reset]');
        this.filterButton = this.root.querySelector('[data-events-filter]');

        this.loaderCalendar = this.root.querySelector(
            '[data-events-loader-calendar]'
        );
        this.loaderList = this.root.querySelector('[data-events-loader-list]');
        this.loaderMore = this.root.querySelector('[data-events-loader-more]');

        this.listHtml = this.list.innerHTML;
        this.calendarHtml = this.calendar.innerHTML;

        this.currentPage = 1;
        this.settings = JSON.parse(this.root.getAttribute('data-settings'));

        this.dateCompareMode = false;
        this.renderCalendar = false;
        this.reloadEvents = true;
        this.dateFilterActive = true;

        this.loadEvents = debounce(this.getEvents, 1000);
        this.loadCalendar = debounce(this.getCalendar, 500);

        return true;
    }

    init() {
        this.setMore();
        this.setDayEvent();
        this.setMonthEvent();
        this.setCurrent();
        this.setResetButton();
    }

    setMore() {
        if (!this.more) return;

        this.onMore = this.onMoreClick.bind(this);
        this.more.addEventListener('click', this.onMore);
    }

    setResetButton() {
        if (!this.resetButton) return;

        this.onReset = this.onResetClick.bind(this);
        this.resetButton.addEventListener('click', this.onReset);
    }

    setMonthEvent() {
        this.calendarPrev = this.root.querySelector('[data-calendar-prev]');
        this.calendarNext = this.root.querySelector('[data-calendar-next]');

        if (!this.calendarPrev || !this.calendarNext) return;

        this.onMonth = this.onMonthClick.bind(this);
        this.calendarPrev.addEventListener('click', event =>
            this.onMonth(event)
        );
        this.calendarNext.addEventListener('click', event =>
            this.onMonth(event)
        );
    }

    setDayEvent() {
        this.calendarDay = this.root.querySelectorAll('[data-calendar-day]');
        if (!this.calendarDay) return;

        this.onDay = this.onDayClick.bind(this);
        this.calendarDay.forEach(day => {
            day.addEventListener('click', event => this.onDay(event));
        });
    }

    setCurrent() {
        this.calendarCurrent = this.root.querySelector(
            '[data-calendar-current]'
        );

        this.onCurrent = this.onCurrentClick.bind(this);
        this.calendarCurrent.addEventListener('click', event =>
            this.onCurrent(event)
        );
    }

    onResetClick(event) {
        const todayDate = new Date().toISOString().slice(0, 10);
        this.currentDate = todayDate;
        this.loadCalendar();

        this.listHtml = '';
        this.currentDate = todayDate;
        this.currentPage = 1;

        this.eventsLoader();
    }

    onCurrentClick(event) {
        const { currentTarget } = event;
        const date = currentTarget.getAttribute('data-calendar-month');
        this.listHtml = '';

        this.currentDate = date;
        this.currentPage = 1;

        this.eventsLoader();
    }

    onDayClick(event) {
        this.resetDays();
        const { currentTarget } = event;
        const date = currentTarget.getAttribute('data-calendar-day');

        if (date === this.currentDate) {
            const currDate = this.calendarCurrent.getAttribute(
                'data-calendar-month'
            );
            this.currentDate = currDate;
            this.dateCompareMode = false;
            this.dateFilterActive = true;
        } else {
            this.currentDate = date;
            this.dateCompareMode = true;
            this.dateFilterActive = true;
            currentTarget.classList.add('active');
        }

        this.listHtml = '';
        this.currentPage = 1;
        this.eventsLoader();
    }

    onMonthClick(event) {
        const { currentTarget } = event;
        const date = currentTarget.getAttribute('data-calendar-month');
        this.listHtml = '';

        this.dateCompareMode = false;
        this.dateFilterActive = false;
        this.currentDate = date;
        this.currentPage = 1;

        this.calendarLoader();
        this.getEvents();
    }

    onMoreClick() {
        this.currentPage = this.currentPage + 1;
        this.reloadEvents = true;
        this.renderCalendar = false;
        this.loaderMore.classList.remove('d-none');
        this.eventsLoader();
    }

    resetDays() {
        const days = this.root.querySelectorAll('[data-calendar-day]');
        if (!days) return;

        days.forEach(day => day.classList.remove('active'));
    }

    eventsLoader() {
        if (this.reloadEvents) this.loaderList.classList.remove('d-none');
        if (this.renderCalendar) this.loaderCalendar.classList.remove('d-none');
        if (this.calendar) this.calendar.classList.add('-loading');
        this.loadEvents();
    }

    calendarLoader() {
        this.loaderCalendar.classList.remove('d-none');
        this.loadCalendar();
    }

    checkMoreButton(maxPages) {
        const moreWrapper = this.root.querySelector('.events-list__more');
        if (this.currentPage === maxPages || maxPages === 0) {
            moreWrapper.classList.add('d-none');
        } else {
            moreWrapper.classList.remove('d-none');
        }
    }

    getEvents() {
        const formData = new FormData();
        formData.append('action', 'events_list');
        formData.append('per_page', 10);
        formData.append('current_page', this.currentPage);
        formData.append('date_comparison', this.dateCompareMode);
        formData.append('filter_calendar', this.filterCalendar);

        if (this.currentDate) formData.append('date', this.currentDate);

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { maxNumPages, html, calendar_html } = data;

                this.maxPages = maxNumPages;
                this.listHtml += html;
                this.list.innerHTML = this.listHtml;
                this.checkMoreButton(maxNumPages);
            }.bind(this),
            error: function () {
                this.loaderList.classList.add('d-none');
                this.loaderMore.classList.add('d-none');
                this.calendar.classList.remove('-loading');
            }.bind(this),
            complete: function () {
                this.loaderList.classList.add('d-none');
                this.loaderMore.classList.add('d-none');
                this.calendar.classList.remove('-loading');
            }.bind(this),
        });
    }

    getCalendar() {
        const formData = new FormData();
        formData.append('action', 'get_calendar');
        formData.append('lang', ajax.lang);

        if (this.currentDate) formData.append('date', this.currentDate);

        $.ajax({
            type: 'POST',
            url: ajax.url,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            data: formData,
            success: function (response) {
                const data = JSON.parse(response);
                const { html } = data;

                this.calendarHtml = html;
                this.calendar.innerHTML = this.calendarHtml;
                this.setCurrent();
                this.setMonthEvent();
                this.setDayEvent();
            }.bind(this),
            error: function () {
                this.loaderCalendar.classList.add('d-none');
            }.bind(this),
            complete: function () {
                this.loaderCalendar.classList.add('d-none');
            }.bind(this),
        });
    }
}

const sections = document.querySelectorAll('[data-events]');
const initEvents = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new EventsList(el);
    });
};

initEvents(sections);
